const students = {
  // Page meta
  pageTitle: 'Students',
  pageSubtitle: 'Manage student enrollment and records',
  totalEnrolled: 'Total <strong>{{count}}</strong> students enrolled across all sections',
  myStudentsTitle: 'My Students',
  myStudentsSubtitle: 'View and manage students in your class',
  teacherTotalEnrolled: '<strong>{{count}}</strong> students enrolled in your class',
  // Table columns
  studentId: 'Student ID',
  name: 'Name',
  class: 'Class',
  className: 'Class / Section',
  teacherName: 'Teacher Name',
  classTeacher: 'Class Teacher',
  dob: 'DoB',
  fatherName: 'Father Name',
  motherName: 'Mother Name',
  contactFather: 'Contact (F)',
  contactMother: 'Contact (M)',
  district: 'District',
  status: 'Status',
  call: 'Call',
  // Status
  enrolled: 'Enrolled',
  pending: 'Pending',
  draft: 'Draft',
  inactive: 'Inactive',
  // Filters
  searchStudents: 'Search students...',
  allClasses: 'All Classes',
  hideInactive: 'Hide Inactive',
  showingInactive: 'Showing Inactive',
  // Enrollment modal
  step1Label: 'Demographics',
  step2Label: 'Guardian Details',
  step3Label: 'Documents',
  studentDemographics: 'Student Demographics',
  guardianInformation: 'Guardian Information',
  documentUpload: 'Document Upload',
  step1Title: 'Student Demographics',
  step2Title: 'Guardian / Parent Information',
  step3Title: 'Document Upload',
  saveDraft: 'Save Draft',
  submitEnroll: 'Submit (Enroll)',
  enterFullName: "Enter student's full name",
  fullResidentialAddress: 'Full residential address',
  selectClassSection: 'Select class section',
  assignedTeacher: 'Assigned Teacher',
  noTeacherAssigned: 'No teacher assigned',
  selectClassFirst: '— Select a class first —',
  fathersFullName: "Father's full name",
  mothersFullName: "Mother's full name",
  parentEmail: 'parent@email.com',
  districtName: 'District name',
  townOrCity: 'Town or city name',
  documentsDescription: 'Upload the required documents. Accepted formats: PDF, JPG, PNG (max 5 MB each).',
  // Class context banner
  enrolledCount: '{{count}} student enrolled',
  enrolledCountPlural: '{{count}} students enrolled',
  backToFaculty: 'Back to Faculty',
  unassigned: 'Unassigned',
  // Edit modal
  editStudent: 'Edit Student',
  saveChanges: 'Save Changes',
  deactivate: 'Deactivate',
  // Documents section
  documents: 'Documents',
  uploadedCount: '{{uploaded}} of {{total}} uploaded',
  requiredMissing: '({{count}} required missing)',
  required: 'Required',
  notUploaded: 'Not uploaded',
  documentPreview: 'Document Preview',
  documentPreviewDescription: 'This is a preview placeholder for <strong>{{fileName}}</strong>. In production, the actual document would render here.',
  pdfDocument: 'PDF Document',
  verified: 'Verified',
  uploadDocument: 'Upload document',
  closePreview: 'Close preview',
  previewDocument: 'Preview document',
  downloadDocument: 'Download document',
  // Status labels
  aadhaarNumber: 'Aadhaar Number',
  udidNumber: 'UDID Number',
  emailAddress: 'Email Address',
  townLabel: 'Town / City',
  // Empty state
  noStudentsFound: 'No students found matching your filters.',
  // Footer
  reactivateStudent: 'Reactivate student',
  confirmReactivation: 'Confirm reactivation',
  reactivateConfirm: 'Reactivate {{name}}?',
  addStudent: 'Add Student',
  // Contact dropdown
  callParent: 'Call Parent',
  father: 'Father',
  mother: 'Mother',
  // Alert / Incident
  alert: 'Alert',
  incident: 'incident',
  incidents: 'incidents',
  incidentsOnly: 'Incidents ({{count}})',
  showingIncidentsOnly: 'Incidents Only',
};

export default students;